export default {
  statistics: {
    total_followers: 'Seguidores totales',
    emails_sent: 'Correos enviados',
    emails_opened: 'Correos abiertos',
    emails_clicked: 'Correos clicados',
    emails_average_open_rate: 'Tasa de apertura',
    emails_average_click_rate: 'Tasa de clics',
    push_notifications_sent: 'Notificaciones push enviadas',
    push_notifications_clicked: 'Notificaciones push clicadas',
  },
};
